import {KTSVG} from 'helpers'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {formatNumberForDisplay} from 'utils/helper'

type AgreedPriceCellProps = {
 agreedPrice: number
 originalPrice?: number
 customerQuotedUnitPrice?: string | number | null
 isEditing: boolean
 draftValue: string
 editable?: boolean
 onStartEdit: () => void
 onDraftChange: (value: string) => void
 onSave: () => void
 onCancel: () => void
}

const AgreedPriceCell = ({
 agreedPrice,
 originalPrice,
 customerQuotedUnitPrice,
 isEditing,
 draftValue,
 editable,
 onStartEdit,
 onDraftChange,
 onSave,
 onCancel,
}: AgreedPriceCellProps) => {
 const {t} = useTranslation()
 const [inputValue, setInputValue] = useState(draftValue)
 const showPriceChanged =
  originalPrice !== undefined &&
  Number(originalPrice) !== Number(agreedPrice)
 const hasCustomerQuotedPrice =
  customerQuotedUnitPrice != null &&
  customerQuotedUnitPrice !== ''
 const showCustomerQuotedStrikethrough =
  !editable && hasCustomerQuotedPrice
 const showCatalogueStrikethrough =
  editable && showPriceChanged
 useEffect(() => {
  if (isEditing) {
   setInputValue(draftValue)
  }
 }, [isEditing, draftValue])

 if (isEditing) {
  return (
   <div className='flex items-center justify-center gap-2 w-full h-full'>
    <input
     type='text'
     value={inputValue}
     autoFocus
     onChange={(e) => {
      setInputValue(e.target.value)
      onDraftChange(e.target.value)
     }}
     className='
      w-[90px]
      min-w-[120px]
       h-[30px]
      px-2
      text-sm
      border
      border-[#4E83E4]
      rounded-md
      text-center
      bg-white
          '
    />

    <button
     type='button'
     onClick={onSave}
     className='
            h-[30px]
            px-3
            bg-[#4E83E4]
            text-white
            text-xs
            font-medium
            rounded-md
          '
    >
     {t('orderManagement.save')}
    </button>

    <button
     type='button'
     onClick={onCancel}
     className='
            h-[30px]
            w-[30px]
            border
            border-[#D7DCE1]
            rounded-md
            flex
            items-center
            justify-center
            bg-white
          '
    >
     ✕
    </button>
   </div>
  )
 }

 return (
  <div className='flex items-center justify-center gap-3 w-full h-full'>
   {showCustomerQuotedStrikethrough && (
    <span className='text-xs text-[#80868C] line-through'>
     {formatNumberForDisplay(
      Number(customerQuotedUnitPrice)
     )}
    </span>
   )}
   {showCatalogueStrikethrough && (
    <span className='text-xs text-[#80868C] line-through'>
     {formatNumberForDisplay(originalPrice)}
    </span>
   )}
   <div
    className='
          min-w-[72px]
          h-[36px]
          px-3
          rounded-md
          bg-[#EEF2F6]
          flex
          items-center
          justify-center
          text-sm
          font-medium
          text-[#33393D]
        '
   >
    {formatNumberForDisplay(agreedPrice)}
   </div>

   {editable && (
    <button
     type='button'
     onClick={onStartEdit}
     className='text-[#4E83E4]'
     aria-label={t('orderManagement.editPrice')}
    >
     <KTSVG
      path={`/media/icons/pencil.svg`}
      svgClassName={`w-6 h-6 text-white p-[2px]`}
     />
    </button>
   )}
  </div>
 )
}

export default AgreedPriceCell
